import { render } from "./Login.vue?vue&type=template&id=6bd22ff9&scoped=true"
import script from "./Login.vue?vue&type=script&lang=js"
export * from "./Login.vue?vue&type=script&lang=js"

import "./Login.vue?vue&type=style&index=0&id=6bd22ff9&scoped=true&lang=css"

import exportComponent from "/Users/abinop/code/Filisia-Dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bd22ff9"]])

export default __exports__